import SessionTimerIframeForPT from 'components/ExpandedNavbar/partials/SessionTimerIframeForPT/SessionTimerIframeForPT';
import { RenderForCountryAndVendor } from 'components/render-for-country-and-vendor';

export function SessionTimerIframe() {
  return (
    <RenderForCountryAndVendor
      allowedCountries={['pt', 'es']}
      allowedVendors={['pokerstars']}
      component={SessionTimerIframeForPT}
    />
  );
}
